import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCaptain = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	width: "32px",
	height: "32px",
	viewBox: "0 0 32 32",
	style: { enableBackground: "new 0 0 32 32" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "icon_circle",
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 16
		})
	}), /* @__PURE__ */ _jsx("g", {
		id: "symbol_K",
		fill: "currentColor",
		children: /* @__PURE__ */ _jsx("path", { d: "M9.5,7.4h3.7v7.4l6.9-7.4h4.5l-6.9,7.2l7.2,9.8h-4.5l-5.3-7.2l-2,2v5.2H9.5V7.4z" })
	})]
});
export default SvgCaptain;
